module.exports = __webpack_public_path__ + "assets/img/cup.2e3b4491.png";